exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".ErrorResolverHandler{height:100%}.ErrorResolverHandler.-hide{display:none}", "",{"version":3,"sources":["styles.scss"],"names":[],"mappings":"AACA,sBAEE,WAAA,CAEA,4BACE,YAAA","file":"styles.scss","sourcesContent":["$theme: zam;\n.ErrorResolverHandler {\n  // HACK to ensure the app sits within a full height window\n  height: 100%;\n\n  &.-hide {\n    display: none;\n  }\n}\n"]}]);

// Exports
exports.locals = {
	"ErrorResolverHandler": "ErrorResolverHandler",
	"-hide": "-hide"
};